__turbopack_context__.v({
  "root": "app-ui-visual-module__MgVHca__root",
});
